<template>
  <ul class="contentWrapper" v-if="resultType === 'ResultArticles'">
    <ResultItem
      v-for="(resultItem, index) in resultsToRender"
      :key="resultItem.id"
      :result="resultItem"
      :resultType="resultType"
      :language="language"
      :itemIndex="index"
      :defaultSiteImageUrl="defaultSiteImageUrl"
    />
  </ul>

  <ul class="splide__list" v-else>
    <ResultItem
      v-for="(resultItem, index) in resultsToRender"
      :key="resultItem.id"
      :result="resultItem"
      :resultType="resultType"
      :language="language"
      :itemIndex="index"
      :defaultSiteImageUrl="defaultSiteImageUrl"
    />
  </ul>
</template>

<script lang="ts">
import ResultItem from "../components/ResultItem.vue";

import { onMounted, defineComponent, PropType, ref, watch } from "vue";
import {
  InterstitialCta,
  ISiteSearchResult,
  ISiteSearchResultItem
} from "../clients/search/src/models";
export default defineComponent({
  components: {
    ResultItem
  },
  props: {
    results: {
      type: Object as PropType<ISiteSearchResult>,
      required: true,
      default: {}
    },
    resultType: {
      type: String,
      required: true,
      default: ""
    },
    ctas: {
      type: Array as PropType<InterstitialCta[]>,
      required: true,
      default: []
    },
    ctaFrequency: {
      type: Number,
      required: true,
      default: 6
    },
    language: {
      type: String,
      required: false,
      default: ""
    },
    defaultSiteImageUrl: {
      type: String,
      required: true,
      default: ""
    }
  },
  setup(props) {
    const ctaIndex = ref(0);
    const resultsToRender = ref([]);

    const blendCtas = (
      siteSearchResults: ISiteSearchResult
    ): (ISiteSearchResultItem | InterstitialCta)[] => {
      const blendedResults: (ISiteSearchResultItem | InterstitialCta)[] = [];
      if (siteSearchResults.currentPage === 1) {
        ctaIndex.value = 0;
      }

      // Some of these declarations are just to shut the TS compiler up. We could do them inline
      // but it makes the code significantly harder to read.
      const indexOffset: number = resultsToRender.value.length - ctaIndex.value;
      const insertFreq: number = props.ctaFrequency as number;
      const allCtas: InterstitialCta[] = props.ctas as InterstitialCta[];

      siteSearchResults.results.forEach((res, index) => {
        blendedResults.push(res);
        if (
          (index + indexOffset + 1) % (insertFreq - 1) === 0 &&
          allCtas.length > ctaIndex.value
        ) {
          blendedResults.push(props.ctas[ctaIndex.value]);
          ctaIndex.value++;
        }
      });
      return blendedResults;
    };

    const buildResultsToRender = () => {
      const resultsFromProps = props.results as ISiteSearchResult;
      if (resultsFromProps.currentPage === 1) {
        resultsToRender.value = [];
        resultsToRender.value = blendCtas(resultsFromProps);
        return;
      }
      resultsToRender.value.push(...blendCtas(resultsFromProps));
    };

    onMounted(() => {
      buildResultsToRender();
    });

    watch(
      () => [props.ctas, props.results],
      () => {
        buildResultsToRender();
      }
    );

    return {
      resultsToRender
    };
  }
});
</script>
